export default __webpack_public_path__ + "static/media/basic_characters_each.b821632a.png";